import React from 'react';
import { motion } from 'framer-motion';
import { Star, Check, CheckCheck, Phone, Video, MoreVertical, ArrowLeft } from 'lucide-react';
interface ChatMessage {
  text: string;
  time: string;
  fromMe: boolean;
  read?: boolean;
}
interface WhatsAppChat {
  contactName: string;
  contactInitial: string;
  avatarColor: string;
  messages: ChatMessage[];
  highlight: string;
}
const chats: WhatsAppChat[] = [{
  contactName: 'Carina S.',
  contactInitial: 'C',
  avatarColor: 'bg-pink-600',
  highlight: '+30% en ventas',
  messages: [{
    text: 'Hola! Quería contarte que desde que activé el bot, mis ventas subieron un 30% 🤯',
    time: '14:32',
    fromMe: false
  }, {
    text: 'Antes estaba 8 horas pegada al celu respondiendo lo mismo',
    time: '14:32',
    fromMe: false
  }, {
    text: 'Ahora solo entro cuando me avisa que ya pagaron jajaja',
    time: '14:33',
    fromMe: false
  }, {
    text: 'Qué bueno Cari!! 🔥 Me alegra mucho',
    time: '14:35',
    fromMe: true,
    read: true
  }, {
    text: 'Recuperé mis tardes con mis hijos, eso no tiene precio 🙏',
    time: '14:36',
    fromMe: false
  }]
}, {
  contactName: 'Sergio M.',
  contactInitial: 'S',
  avatarColor: 'bg-blue-600',
  highlight: '15 turnos en un finde',
  messages: [{
    text: 'Crack, te cuento que el finde me fui de viaje y el bot me agendó 15 turnos solo 😂',
    time: '10:15',
    fromMe: false
  }, {
    text: 'Jajaja en serio?? 💪',
    time: '10:18',
    fromMe: true,
    read: true
  }, {
    text: 'Sii, mis clientas ni se dan cuenta que es IA. Con los prompts que armamos quedó perfecto',
    time: '10:19',
    fromMe: false
  }, {
    text: 'Tenía miedo de que sonara frío pero nada que ver',
    time: '10:19',
    fromMe: false
  }]
}, {
  contactName: 'Luciana R.',
  contactInitial: 'L',
  avatarColor: 'bg-purple-600',
  highlight: '4 hs libres por día',
  messages: [{
    text: 'No puedo creer que no hice esto antes 😭',
    time: '19:45',
    fromMe: false
  }, {
    text: 'Qué pasó Lu?',
    time: '19:47',
    fromMe: true,
    read: true
  }, {
    text: 'El bot responde las mismas 50 preguntas que yo respondía todos los días. Precio, talle, envío, link de pago...',
    time: '19:48',
    fromMe: false
  }, {
    text: 'Me liberó como 4 horas por día MÍNIMO',
    time: '19:48',
    fromMe: false
  }, {
    text: 'Y encima manda el link de Mercado Pago solo 🤑',
    time: '19:49',
    fromMe: false
  }]
}, {
  contactName: 'Facundo G.',
  contactInitial: 'F',
  avatarColor: 'bg-orange-600',
  highlight: 'Ventas a las 3 AM',
  messages: [{
    text: 'Loco a las 3 de la mañana me entró una venta 😂',
    time: '09:12',
    fromMe: false
  }, {
    text: 'El bot le respondió todo, le pasó el link y pagó',
    time: '09:12',
    fromMe: false
  }, {
    text: 'Yo me enteré cuando me desperté jajaja',
    time: '09:13',
    fromMe: false
  }, {
    text: 'Eso es lo mejor, vende mientras dormís 💰',
    time: '09:15',
    fromMe: true,
    read: true
  }, {
    text: 'Literal. Mejor inversión que hice este año',
    time: '09:16',
    fromMe: false
  }]
}];
function WhatsAppMockup({
  chat,
  index
}: {
  chat: WhatsAppChat;
  index: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 25
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.15
  }} className="rounded-2xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-189">
      {/* WhatsApp Header */}
      <div className="bg-[#1F2C34] px-3 py-2.5 flex items-center gap-3" data-id="element-190">
        <ArrowLeft className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-191" />
        <div className={`w-9 h-9 rounded-full ${chat.avatarColor} flex items-center justify-center text-white font-bold text-sm flex-shrink-0`} data-id="element-192">
          {chat.contactInitial}
        </div>
        <div className="flex-1 min-w-0" data-id="element-193">
          <p className="text-white text-sm font-semibold truncate" data-id="element-194">
            {chat.contactName}
          </p>
          <p className="text-gray-400 text-xs" data-id="element-195">en línea</p>
        </div>
        <div className="flex items-center gap-4 text-gray-400" data-id="element-196">
          <Video className="w-5 h-5" data-id="element-197" />
          <Phone className="w-4 h-4" data-id="element-198" />
          <MoreVertical className="w-5 h-5" data-id="element-199" />
        </div>
      </div>

      {/* Chat Body */}
      <div className="bg-[#0B141A] px-3 py-4 space-y-1.5 min-h-[220px]" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='p' width='40' height='40' patternUnits='userSpaceOnUse'%3E%3Ccircle cx='20' cy='20' r='1' fill='%23ffffff08'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='200' height='200' fill='url(%23p)'/%3E%3C/svg%3E\")"
    }} data-id="element-200">
        {chat.messages.map((msg, i) => <div key={i} className={`flex ${msg.fromMe ? 'justify-end' : 'justify-start'}`} data-id="element-201">
            <div className={`max-w-[85%] px-3 py-1.5 rounded-lg text-sm leading-relaxed ${msg.fromMe ? 'bg-[#005C4B] text-white rounded-tr-none' : 'bg-[#1F2C34] text-gray-100 rounded-tl-none'}`} data-id="element-202">
              <span data-id="element-203">{msg.text}</span>
              <span className="inline-flex items-center gap-1 ml-2 float-right mt-1" data-id="element-204">
                <span className="text-[10px] text-gray-400" data-id="element-205">{msg.time}</span>
                {msg.fromMe && <CheckCheck className={`w-3.5 h-3.5 ${msg.read ? 'text-[#53BDEB]' : 'text-gray-400'}`} data-id="element-206" />}
              </span>
            </div>
          </div>)}
      </div>

      {/* Highlight Badge */}
      <div className="bg-[#1F2C34] px-4 py-2.5 border-t border-white/5 flex items-center justify-center gap-2" data-id="element-207">
        <span className="text-[#25D366] text-xs font-bold" data-id="element-208">
          📈 {chat.highlight}
        </span>
      </div>
    </motion.div>;
}
export function SocialProofSection() {
  return <section className="py-14 px-4 bg-[#0a0a0a] border-y border-white/5 relative" data-id="element-209">
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-32 h-64 bg-[#25D366]/10 blur-[80px] -z-10" data-id="element-210" />

      <div className="max-w-5xl mx-auto" data-id="element-211">
        <div className="text-center mb-10" data-id="element-212">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-213">
            Resultados Reales de Negocios Reales
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-214">
            Conversaciones reales con nuestros clientes
          </p>
          <div className="flex justify-center gap-1 mt-4" data-id="element-215">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#25D366] text-[#25D366]" data-id="element-216" />)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-217">
          {chats.map((chat, index) => <WhatsAppMockup key={index} chat={chat} index={index} data-id="element-218" />)}
        </div>
      </div>
    </section>;
}